"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _reactVis = require("react-vis");

var _luxon = require("luxon");

var _Icon = _interopRequireDefault(require("./Icon"));

var _ResizableXYPlot = _interopRequireDefault(require("./ResizableXYPlot"));

var _readingsToCoordinates = require("../transformers/readingsToCoordinates");

var _colors = require("../constants/colors");

var _styles = require("../styles");

var _helpers = require("../helpers");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 11;\n  margin-right: 30px;\n  margin-bottom: 20px;\n"])));

var HintBody = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: ", ";\n  box-sizing: border-box;\n  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);\n  color: ", ";\n  max-width: ", "px;\n  padding: 15px 20px;\n  > div {\n    font-size: 16px;\n    line-height: 20px;\n    margin-bottom: 10px;\n  }\n  width: ", "px;\n"])), _colors.WHITE, _colors.NAVY, function (props) {
  return props.width;
}, function (props) {
  return props.width;
});

var Truck = (0, _styled["default"])(_Icon["default"])(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 0;\n"])));
var hintWidth = 420;

var FieldServiceActivityChart = function FieldServiceActivityChart(_ref) {
  var fieldServiceActivity = _ref.fieldServiceActivity,
      viewStartISO = _ref.viewStartISO,
      viewEndISO = _ref.viewEndISO,
      zone = _ref.zone;

  var viewStartDateTime = _luxon.DateTime.fromISO(viewStartISO, {
    zone: zone
  });

  var viewEndDateTime = _luxon.DateTime.fromISO(viewEndISO, {
    zone: zone
  });

  var coordinates = (0, _readingsToCoordinates.fieldServiceActivityToCoordinates)(fieldServiceActivity, zone, 0, 100);

  var wrapperEl = /*#__PURE__*/_react["default"].createRef();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCoordinate = _useState2[0],
      setSelectedCoordinate = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      cursorX = _useState4[0],
      setCursorX = _useState4[1];

  var _useState5 = (0, _react.useState)('right'),
      _useState6 = _slicedToArray(_useState5, 2),
      cursorAlignment = _useState6[0],
      setCursorAlignment = _useState6[1];

  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    ref: wrapperEl
  }, /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    dataTestid: "field-service-activity-chart",
    dontCheckIfEmpty: true,
    height: 15,
    margin: {
      top: 0,
      left: 70,
      right: 0,
      bottom: 0
    },
    onMouseMove: function onMouseMove(e) {
      // Cursor X needs to be relative to the wrapper
      var rect = wrapperEl.current.getBoundingClientRect();
      var clientX = e.clientX;
      setCursorX(clientX - rect.x);
      var halfwayX = rect.x + rect.width / 2;

      if (clientX < halfwayX) {
        setCursorAlignment('right');
      } else {
        setCursorAlignment('left');
      }
    },
    onMouseLeave: function onMouseLeave() {
      return setSelectedCoordinate(null);
    },
    xDomain: [viewStartDateTime.toMillis(), viewEndDateTime.toMillis()]
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalRectSeries, {
    colorType: "literal",
    data: coordinates,
    style: {
      fill: _colors.FADED_GREY,
      stroke: _colors.FADED_GREY
    },
    onValueMouseOver: function onValueMouseOver(c) {
      return setSelectedCoordinate(c);
    },
    onValueMouseOut: function onValueMouseOut() {
      return setSelectedCoordinate(null);
    }
  }), selectedCoordinate && /*#__PURE__*/_react["default"].createElement(_reactVis.Hint, {
    getAlignStyle: function getAlignStyle() {
      return cursorAlignment === 'right' ? {
        left: cursorX
      } : {
        left: cursorX - hintWidth
      };
    },
    value: selectedCoordinate
  }, /*#__PURE__*/_react["default"].createElement(HintBody, {
    width: hintWidth
  }, /*#__PURE__*/_react["default"].createElement("div", null, "Case Number - ".concat(selectedCoordinate.caseNumber)), /*#__PURE__*/_react["default"].createElement("div", null, "Case Status - ".concat(selectedCoordinate.status || selectedCoordinate.caseStatus)), /*#__PURE__*/_react["default"].createElement("div", null, "Case Created Date - ".concat(selectedCoordinate.createdDate ? (0, _helpers.dateTimeFormat)(_luxon.DateTime.fromISO(selectedCoordinate.createdDate, {
    zone: zone
  })) : 'N/A')), /*#__PURE__*/_react["default"].createElement("div", null, "Case Closed Date - ".concat(selectedCoordinate.closedDate ? (0, _helpers.dateTimeFormat)(_luxon.DateTime.fromISO(selectedCoordinate.closedDate, {
    zone: zone
  })) : 'Still open')), /*#__PURE__*/_react["default"].createElement("div", null, "Case Reason - ".concat(selectedCoordinate.reason)), /*#__PURE__*/_react["default"].createElement("div", null, "Subset Reason - ".concat(selectedCoordinate.subsetReason || selectedCoordinate.subreason)))), /*#__PURE__*/_react["default"].createElement(_reactVis.Borders, {
    style: _styles.borderStyle
  })), /*#__PURE__*/_react["default"].createElement(Truck, {
    name: "TruckIcon"
  }));
};

FieldServiceActivityChart.propTypes = {
  viewStartISO: _propTypes["default"].string.isRequired,
  viewEndISO: _propTypes["default"].string.isRequired,
  zone: _propTypes["default"].string,
  fieldServiceActivity: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    actionCodeName: _propTypes["default"].string,
    actionId: _propTypes["default"].string,
    actionName: _propTypes["default"].string,
    caseId: _propTypes["default"].string,
    caseNumber: _propTypes["default"].string,
    caseStatus: _propTypes["default"].string,
    closedDate: _propTypes["default"].string,
    componentCode: _propTypes["default"].string,
    componentCodeName: _propTypes["default"].string,
    createdDate: _propTypes["default"].string,
    dispatchFindings: _propTypes["default"].string,
    dispatchId: _propTypes["default"].string,
    dispatchName: _propTypes["default"].string,
    dispatchTime: _propTypes["default"].string,
    origin: _propTypes["default"].string,
    reason: _propTypes["default"].string,
    serviceContractName: _propTypes["default"].string,
    status: _propTypes["default"].string,
    subreason: _propTypes["default"].string,
    subsetReason: _propTypes["default"].string
  }))
};
FieldServiceActivityChart.defaultProps = {
  fieldServiceActivity: [],
  zone: 'local'
};
var _default = FieldServiceActivityChart;
exports["default"] = _default;